import { HttpClient, HttpHeaders } from '@angular/common/http';

import { PagedResult } from '../Models/PagedResult';
import { SelectItems, listKeyitem } from '../Models/SelectItems';

import { Observable } from 'rxjs';
import { authenticationService } from './authenticationService';
import { QueryModel } from '../Models/queryModel';
import { environment } from '../../../../environments/environment';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BaseService {
  headers = new HttpHeaders();
  constructor(public http: HttpClient, private authenticationSerives: authenticationService, private url: string) {
    this.authenticationSerives.createAuthorizationHeader();
    this.headers = this.authenticationSerives.headers;
  }
  get(queryModel: QueryModel, url: string = ''): Observable<PagedResult> {
    return this.http.get<PagedResult>(this.url + url, {
      params: {
        currentPage: queryModel.currentPage.toString(),
        pageSize: queryModel.pageSize.toString(),
        sort: queryModel.sort,
        sortDirection: queryModel.sortDirection,
        searchTerm: queryModel.searchTerm,
      },
      headers: this.getAuthorizationHeader(),
    });
  }

  getApi(route: string) {
    return this.http.get<PagedResult>(this.url + '/' + route, {
      headers: this.getAuthorizationHeader(),
    });
  }

  getData(route: string , searchTerm?:string ) {
    if (searchTerm ) {
      return this.http.get<any>(this.url + '/' + route + '?searchTerm=' + searchTerm, {
        headers: this.getAuthorizationHeader(),
      });
    }
    else {
    return this.http.get<any>(this.url + '/' + route, {
      headers: this.getAuthorizationHeader(),
    });
  }
  }

  getAll(queryModel: QueryModel, domain: string): Observable<PagedResult> {
    return this.http.get<PagedResult>(this.url + domain, {
      params: {
        currentPage: queryModel.currentPage.toString(),
        pageSize: queryModel.pageSize.toString(),
        sort: queryModel.sort,
        sortDirection: queryModel.sortDirection,
        searchTerm: queryModel.searchTerm,
      },
      headers: this.getAuthorizationHeader(),
    });
  }

  getById(id: number) {
    return this.http.get<any>(this.url + '/' + id, {
      headers: this.getAuthorizationHeader(),
    });
  }

  post(object: any, url: string = '') {
    return this.http.post<any>(this.url + url, object, {
      headers: this.getAuthorizationHeader(),
    });
  }

  delete(id: number) {
    return this.http.delete(this.url + '/' + id, {
      headers: this.getAuthorizationHeader(),
    });
  }

  put(id: number, object: any) {
    return this.http.put(this.url + '/' + id, object, {
      headers: this.getAuthorizationHeader(),
    });
  }

  putBulk(object: any, url) {
    return this.http.put(this.url + '/' + url, object, {
      headers: this.getAuthorizationHeader(),
    });
  }

  getCreate() {
    return this.http.get<SelectItems[]>(this.url + '/Create', {
      headers: this.getAuthorizationHeader(),
    });
  }

  getCreateNew() {
    return this.http.get<listKeyitem[]>(this.url + '/Create', {
      headers: this.getAuthorizationHeader(),
    });
  }

  uploadFile(files: any) {
    return this.http.post<any>(environment.apiUrl + 'UploadFile/Upload', files, {
      headers: this.getAuthorizationHeader(),
    });
  }

  uploadMultipleFiles(files: any) {
    return this.http.post<any>(environment.apiUrl + 'UploadFile/UploadMultiple', files, {
      headers: this.getAuthorizationHeader(),
    });
  }

  downloadFile(filename) {
    return this.http.post<any>(
      environment.apiUrl + 'UploadFile/Download',
      { filename: filename },
      { headers: this.getAuthorizationHeader(), responseType: 'blob' as 'json' }
    );
  }
  saveFile(object: any) {
    return this.http.post(environment.apiUrl + 'UploadFile/SaveFile', object);
  }
  getUpdate(objId) {
    return this.http.get<any>(this.url + '/Update/' + objId, {
      headers: this.getAuthorizationHeader(),
    });
  }
  getAuthorizationHeader() {
    return new HttpHeaders({
        'ngrok-skip-browser-warning': 'true',
      Authorization: 'Bearer ' + sessionStorage.getItem('serviceAdmintoken'),
    });
  }

  getServiceTypes(  ){
    return this.http.get<any>(environment.apiUrl + 'ServicesTypes', {
      params:{
        pageSize:'100'
      },
      headers: this.getAuthorizationHeader(),
    });
  }
}
